module.exports = __webpack_public_path__ + "img/casa-de-linhares.b86b77eb.jpg";